// CAT Mock 5 — DILR section.
const catMock5Dilr = [
  {
    id: 25,
    type: "mcq",
    setId: "di1",
    statement: `The table shows the total deposits and total loans (in ₹ crore) of five branches of a bank, A–E, at the end of 2023 and 2024. The loan-to-deposit ratio of a branch is (Loans ÷ Deposits) × 100.`,
    table: {
      columns: ["Branch", "Deposits 2023", "Deposits 2024", "Loans 2023", "Loans 2024"],
      rows: [
        ["A", "120", "150", "80", "90"],
        ["B", "200", "220", "150", "176"],
        ["C", "90", "81", "60", "72"],
        ["D", "160", "208", "100", "110"],
        ["E", "130", "143", "91", "104"]
      ]
    },
    question: "Which branch recorded the highest percentage growth in deposits from 2023 to 2024?",
    options: [
      "A. Branch A",
      "B. Branch B",
      "C. Branch C",
      "D. Branch D"
    ],
    answer: "D"
  },
  {
    id: 26,
    type: "tita",
    setId: "di1",
    question: "What was the loan-to-deposit ratio of Branch B in 2024?",
    answer: "80"
  },
  {
    id: 27,
    type: "mcq",
    setId: "di1",
    question: "In how many branches did the loan-to-deposit ratio increase from 2023 to 2024?",
    options: [
      "A. 1",
      "B. 2",
      "C. 3",
      "D. 4"
    ],
    answer: "C"
  },
  {
    id: 28,
    type: "tita",
    setId: "di1",
    question: "By how much (in ₹ crore) did the total deposits of all five branches exceed their total loans in 2024?",
    answer: "250"
  },
  {
    id: 29,
    type: "mcq",
    setId: "di1",
    question: "If each branch's deposits grow from 2024 to 2025 by the same percentage as they did from 2023 to 2024, which branch will have the largest deposits in 2025?",
    options: [
      "A. Branch B",
      "B. Branch D",
      "C. Branch A",
      "D. Branch E"
    ],
    answer: "B"
  },
  {
    id: 30,
    type: "mcq",
    setId: "di2",
    statement: `Five friends — P, Q, R, S and T — live on the five floors of a building, numbered 1 (lowest) to 5 (top), one person per floor. Each owns a different pet (cat, dog, fish, parrot, rabbit) and prefers a different drink (coffee, juice, milk, tea, water).
• Q lives on the top floor.
• P lives exactly two floors above R.
• The dog owner lives on the middle floor.
• S lives immediately above the dog owner.
• The fish owner lives on the lowest floor.
• The parrot owner lives on a higher floor than the rabbit owner.
• T does not own the rabbit.
• The milk drinker owns the parrot.
• The coffee drinker lives immediately above the juice drinker.
• The cat owner drinks neither coffee nor juice.
• The fish owner drinks tea.`,
    question: "Who owns the cat?",
    options: [
      "A. R",
      "B. S",
      "C. T",
      "D. P"
    ],
    answer: "C"
  },
  {
    id: 31,
    type: "tita",
    setId: "di2",
    question: "On which floor does the coffee drinker live?",
    answer: "4"
  },
  {
    id: 32,
    type: "mcq",
    setId: "di2",
    question: "What does P prefer to drink?",
    options: [
      "A. Tea",
      "B. Juice",
      "C. Coffee",
      "D. Water"
    ],
    answer: "B"
  },
  {
    id: 33,
    type: "mcq",
    setId: "di2",
    question: "Which of the following statements is true?",
    options: [
      "A. S owns the parrot.",
      "B. R drinks water.",
      "C. The rabbit owner lives immediately below Q.",
      "D. T lives on floor 3."
    ],
    answer: "C"
  },
  {
    id: 34,
    type: "tita",
    setId: "di2",
    question: "What is the sum of the floor numbers of the water drinker and the rabbit owner?",
    answer: "6"
  },
  {
    id: 35,
    type: "mcq",
    setId: "di2",
    question: "Who lives immediately above the tea drinker?",
    options: [
      "A. T",
      "B. P",
      "C. S",
      "D. Q"
    ],
    answer: "A"
  },
  {
    id: 36,
    type: "tita",
    setId: "di3",
    statement: `A survey of 300 people asked which of three streaming services — X, Y and Z — they subscribe to.
• 150 people subscribe to X, 130 to Y and 120 to Z.
• 50 subscribe to both X and Y, 40 to both Y and Z, and 45 to both X and Z. (Each of these counts includes those who subscribe to all three.)
• 20 people subscribe to all three services.`,
    question: "How many of the people surveyed subscribe to none of the three services?",
    answer: "15"
  },
  {
    id: 37,
    type: "mcq",
    setId: "di3",
    question: "How many people subscribe to exactly one of the three services?",
    options: [
      "A. 175",
      "B. 190",
      "C. 200",
      "D. 185"
    ],
    answer: "B"
  },
  {
    id: 38,
    type: "tita",
    setId: "di3",
    question: "How many people subscribe to exactly two of the three services?",
    answer: "75"
  },
  {
    id: 39,
    type: "mcq",
    setId: "di3",
    question: "Of the people who subscribe to Z, approximately what percentage also subscribe to at least one other service?",
    options: [
      "A. 54%",
      "B. 46%",
      "C. 50%",
      "D. 58%"
    ],
    answer: "A"
  },
  {
    id: 40,
    type: "mcq",
    setId: "di3",
    question: "After the survey, every person who subscribed to exactly two services also took up the third. How many people now subscribe to all three services?",
    options: [
      "A. 75",
      "B. 90",
      "C. 95",
      "D. 100"
    ],
    answer: "C"
  },
  {
    id: 41,
    type: "tita",
    setId: "di4",
    statement: `The table shows the number of smartphones (in thousand units) sold by four brands in each quarter of a year, along with each brand's average selling price per unit (in ₹ thousand), which stayed the same throughout the year. Revenue = Units sold × Average selling price.`,
    table: {
      columns: ["Brand", "Q1", "Q2", "Q3", "Q4", "Avg. price (₹ '000)"],
      rows: [
        ["Alpha", "40", "45", "50", "65", "20"],
        ["Beta", "55", "50", "60", "55", "15"],
        ["Gamma", "30", "36", "42", "48", "25"],
        ["Delta", "25", "30", "28", "32", "30"]
      ]
    },
    question: "How many smartphones (in thousand units) did the four brands sell in total in Q3?",
    answer: "180"
  },
  {
    id: 42,
    type: "mcq",
    setId: "di4",
    question: "Which brand earned the highest revenue for the whole year?",
    options: [
      "A. Gamma",
      "B. Alpha",
      "C. Delta",
      "D. Beta"
    ],
    answer: "B"
  },
  {
    id: 43,
    type: "tita",
    setId: "di4",
    question: "What was Gamma's share (in %) of the total units sold by the four brands in Q4?",
    answer: "24"
  },
  {
    id: 44,
    type: "mcq",
    setId: "di4",
    question: "For how many brands did unit sales rise in every quarter compared with the previous quarter?",
    options: [
      "A. 2",
      "B. 1",
      "C. 3",
      "D. 4"
    ],
    answer: "A"
  },
  {
    id: 45,
    type: "tita",
    setId: "di4",
    question: "What was Delta's revenue for the whole year (in ₹ crore)? (₹1 crore = ₹1,00,00,000.)",
    answer: "345"
  },
  {
    id: 46,
    type: "mcq",
    setId: "di4",
    question: "Which brand recorded the greatest percentage increase in unit sales from Q1 to Q4?",
    options: [
      "A. Gamma",
      "B. Delta",
      "C. Beta",
      "D. Alpha"
    ],
    answer: "D"
  }
];

export default catMock5Dilr;
